const generateColor = (hexColor, magnitude) => {
    hexColor = hexColor.replace(`#`, ``);
    if (hexColor?.length === 6) {
        const decimalColor = parseInt(hexColor, 16);
        let r = (decimalColor >> 16) + magnitude;
        r > 255 && (r = 255);
        r < 0 && (r = 0);
        let g = ((decimalColor >> 8) & 0x00ff) + magnitude;
        g > 255 && (g = 255);
        g < 0 && (g = 0);
        let b = (decimalColor & 0x0000ff) + magnitude;
        b > 255 && (b = 255);
        b < 0 && (b = 0);
        return `#${((r << 16) | (g << 8) | b).toString(16).padStart(6, '0')}`;
    } else {
        return hexColor;
    }
};

export {
    generateColor
};